import { createRoot } from 'react-dom/client';
import * as vp from 'vopay';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { MainProvider } from '@/providers/Main.provider';

import SessionManager from '@/components/Logging/SessionManager';
import PageNavLogger from '@/components/Logging/PageNavLogger';
import NativeButtonLogger from '@/components/Logging/NativeButtonLogger';
import App from '@/App';

const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <Router getUserConfirmation={vp.UserNavPrompt}>
      <MainProvider>
        <SessionManager>
          <PageNavLogger>
            <NativeButtonLogger>
              <App />
            </NativeButtonLogger>
          </PageNavLogger>
        </SessionManager>
      </MainProvider>
    </Router>
  </React.StrictMode>,
);
